import React, {useEffect, useState} from 'react';
import FormSummary from "../component/FormSummary";
import {useDispatch, useSelector} from "react-redux";
import PersonalDataForm from "./PersonalDataForm";
import AdditionalDataForm from "./AdditionalDataForm";
import {getContractRequest} from "../redux/actions/contractActions";
import {RESET_CONTRACTS_LOADED} from "../redux/constants/contractActionTypes";
import ContractDataForm from "./ContractDataForm"; // Adjust the path to the DetailCard component
import { useParams } from 'react-router-dom';

const ContractContainerPage = ({ id: propId }) => {
    const dispatch = useDispatch();
    const [currentStep, setCurrentStep] = useState(1);

    // Hole die ID aus dem URL-Parameter (falls vorhanden)
    const { id: paramId } = useParams();

    // Priorisierung: propId > paramId > default (0)
    const contractID = propId ?? (paramId ? parseInt(paramId, 10) : 0);

    const contract = useSelector(state => state.contract.contract);
    const contractsLoaded = useSelector(state => state.contract.contractsLoaded);
    const isLoadingGetContract = useSelector(state => state.contract.loading.getContract);
    const contractLoaded = useSelector(state => state.contract.contractLoaded);
    const selectedRole = useSelector(state => state.authentication.selectedRole);
    const userGroups = useSelector(state => state.authentication.userGroups);

    const isInstitute = selectedRole ? (selectedRole === 'institute' || selectedRole === 'assistatnt') : (userGroups.includes('institute') || userGroups.includes('assistant'));
    const isHR = selectedRole ? selectedRole === 'humanressource' : userGroups.includes('humanressource');

    useEffect(() => {
        if (contractsLoaded) {
            dispatch({ type: RESET_CONTRACTS_LOADED });
        }

        if (!contract.ID && !isLoadingGetContract && !contractLoaded) {
            dispatch(getContractRequest({ contractID }));
        }
    }, [dispatch, contract, isLoadingGetContract, contractLoaded, contractsLoaded, contractID]);


    const goToPreviousStep = () => setCurrentStep(currentStep - 1);
    const goToNextStep = () => setCurrentStep(currentStep + 1);

    const renderStep = () => {
        let submitButtonText = "Weiter";
        if (currentStep === 3) {
            submitButtonText = "Speichern";
        }
        if (contract && contract.Status === "RECTORATE" && (!(isHR || isInstitute)) && currentStep === 1) {
            setCurrentStep(2);
        }
        switch (currentStep) {
            case 1:
                return <PersonalDataForm
                    contract={contract}
                    setCurrentStep={goToNextStep}
                    previousStep={goToPreviousStep}
                    submitButtonText={submitButtonText}
                />;
            case 2:
                return <AdditionalDataForm
                    contract={contract}
                    setCurrentStep={goToNextStep}
                    previousStep={goToPreviousStep}
                    submitButtonText={submitButtonText}
                />;
            case 3:
                return <ContractDataForm
                    contract={contract}
                    setCurrentStep={goToNextStep}
                    previousStep={goToPreviousStep}
                    submitButtonText={submitButtonText}
                />;
            case 4:
                return <FormSummary
                    contract={contract}
                    previousStep={goToPreviousStep}
                    submitButtonText={submitButtonText}
                />;
            default:
                return <div>
                    <h1>Ungültiger Schritt</h1>
                </div>;
        }
    };

    return (
        <div className="container mt-5">
            <div className="mb-3">
                {renderStep()}
            </div>
        </div>
    );
};

export default ContractContainerPage;
